module.exports = __webpack_public_path__ + "static/media/arrow_icon_off.59b71783.svg";